import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"

import { updatePageState } from "../../../data/store/pageSlice"
import { verifyEmailToken } from "../../../data/store/authSlice"

import SpinnerLoader from "../SpinnerLoader"
import { APP_PAGES, ROUTE_PATH } from "../../../data/configs/constants"
import { notification } from "antd"
import Notify, { notify } from "../Notify"

const EmailVerification = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(
      updatePageState({
        currentPage: APP_PAGES.VERIFY_EMAIL,
        currentSiderModule: "",
      })
    )
  }, [dispatch])

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    if (queryParams.has("token")) {
      dispatch(
        verifyEmailToken({
          token: queryParams.get("token"),
        })
      )
        .unwrap()
        .then((res) => {
          notify.success({ message: res?.message || "Email verified successfully" })
          navigate(ROUTE_PATH.LOGIN)
        })
        .catch(() => {
          navigate(ROUTE_PATH.LOGIN)
        })
    } else {
      notify.error({ message: "Missing Token" })
      navigate(ROUTE_PATH.LOGIN)
    }
  }, [dispatch, navigate])

  return (
    <>
      <Notify />
      <SpinnerLoader brand />
    </>
  )
}

export default EmailVerification
